// extracted by mini-css-extract-plugin
export var formContainer = "_kw-0";
export var message = "_kw-1";